import * as React from "react";
import { LoginAsync } from "source/app/presentation/Login/Helpers/LoginAsync";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import Login from "../Login";
import Render from "../../Shared/Render";

export function LoginGoLink({ Login }: { Login: Login }) {
    const state = Login.state;
    const shouldRender =
        state.username !== `` &&
        state.password !== `` &&
        state.totpToken !== ``;

    return (
        <Render id="LoginGoLink" when={shouldRender}>
            <span className="Login_Go">
                <IconWithText
                    displayAsBlock={true}
                    iconSuffix={EGlyphicon.ok}
                    whenClicked={() => LoginAsync(Login)}
                >
                    {Login.state.fingerprint.isFingerprinted
                        ? "Automatically logging in..."
                        : "Go"}
                </IconWithText>
            </span>
        </Render>
    );
}
